<div class="container">
    <div class="card flat">
        <div class="card-body">
            <h5 class="card-title">Save Time and Money</h5>
            <div class="row">
                <div class="col-6">
                    <a (click)="goPromoStacks()">
                        <div class="subcard promo-stacks">
                            <div class="subcard-body">
                                <div>
                                    <div class="subcard-body-container-image">
                                        <img src="../../../assets/img/home/widgets/update-jun-24/promo-stacks.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div class="subcard-body-container">
                                        <h6 class="subcard-body-container-title">Promo Stacks</h6>
                                        <p class="subcard-body-container-text">Schedule multiple promos with one click.</p>
                                        <div class="flex cta">
                                            <a class="button-action promo-stacks" (click)="goPromoStacks()">Run a Promo Stack</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-6">
                    <a (click)="goReaderReachFacebook()">
                        <div class="subcard reader-reach-facebook-ads">
                            <div class="subcard-body">
                                <div>
                                    <div class="subcard-body-image">
                                        <img src="../../../assets/img/home/widgets/update-jun-24/reader-reach-facebook-ads.svg" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div class="subcard-body-container">
                                        <h6 class="subcard-body-container-title">Drive Facebook Traffic</h6>
                                        <p class="subcard-body-container-text">Accelerate your book sales with fully managed Facebook & Instagram ads.</p>
                                        <div class="flex cta">
                                            <a class="button-action reader-reach-facebook-ads" (click)="goReaderReachFacebook()" target="_blank">Run Facebook & IG Ads</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
